// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import type { Limits, CollapsibleButtonText } from '../types';
import type { ColorScheme } from '../../../types/theme';
import Title from './title';
import SubTitle from './subTitle';
import CollapseButton from './collapseButton';

type Props = {
  scheme: ColorScheme,
  title?: ?string,
  subtitle?: ?string,
  onCollapse: Function,
  buttonText: string,
  nbItems: number,
  buttonText: CollapsibleButtonText,
  collapsed: boolean,
  collapsible?: boolean,
  limits: ?Limits,
  minimalistic: boolean,
};

const Collapse = styled<any, Theme>('section')`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const MinimalTitle = styled<typeof Title, Theme>(Title)`
  font-size: ${props => props.theme.list.title.minimalFontSize};
`;

type MinimalSubTitleProps = {
  onClick: Function,
  collapsed: boolean,
};
const MinimalSubTitle = styled<typeof SubTitle, Theme, MinimalSubTitleProps>(SubTitle)`
  font-size: ${props => props.theme.list.title.minimalFontSize};
  ${props => props.onClick && css`cursor: pointer;`};
`;

const MinimalListHeader = ({
  scheme,
  title,
  subtitle,
  onCollapse,
  collapsed,
  collapsible,
  nbItems,
  buttonText,
  limits,
  minimalistic,
}: Props) => (
  <header>
    {title && (
      <MinimalTitle scheme={scheme}>{title}</MinimalTitle>
    )}
    <Collapse>
      {subtitle && (
        <MinimalSubTitle
          scheme={scheme}
          onClick={onCollapse}
          collapsed={collapsed}
        >
          {subtitle}
        </MinimalSubTitle>
      )}
      <CollapseButton
        scheme={scheme}
        onClick={onCollapse}
        collapsed={collapsed}
        collapsible={collapsible}
        limits={limits}
        nbItems={nbItems}
        minimalistic={minimalistic}
        buttonText={buttonText}
      />
    </Collapse>
  </header>
);

MinimalListHeader.defaultProps = {
  title: null,
  subtitle: null,
  collapsible: false,
};

export default MinimalListHeader;
